import { CSSResultArray } from 'lit';
import host from '@maersk-global/mds-components-utils/host/host.styles.js';
import style from './mc-input.scss';
import tokens from '@maersk-global/mds-design-tokens/implementation/core/input/js/design-tokens-px.css.js';
export const styles: CSSResultArray = [host, tokens, style];
